import Api from './ApiService';

export default class FormatsService {
  static fetchAll() {
    return Api.get('/formats');
  }

  static fetchOneBySlug(slug) {
    return Api.get(`/formats/slug/${slug}`);
  }
}
